// extracted by mini-css-extract-plugin
export default {"tooltip":"zn-z","sharingV2":"An-z","sharingIconsV2":"Bn-z","links":"Cn-z","link":"Dn-z","facebookV2":"En-z","twitterV2":"Fn-z","pinterestV2":"Gn-z"};